let deferredUrl = null;
export function getDeferredDeepLinkUrl() {
    return deferredUrl;
}
export function setDeferredDeepLinkUrl(url) {
    deferredUrl = url;
}
